<script>
  export let page
</script>

<section class="bg-tertiary-200 space-y-2 mb-4 pb-1">
  <p>Pro ovládání zoom komponenty s obrázkem stránky je doporučena myš s kolečkem</p>
  <p>Také jsou podpovány klávezy +/- pro zoom a kurzorové šipky nebo w/a/s/d pro posun</p>
  <!-- <p>Tlačítko reset znovu načte uložená data ze serveru, neuložené změny se ztratí!</p> -->
  <p>Tlačítko vyřadit vyřadí číslo periodika ze zpracování (např. pro nevyhovující kvalitu OCR)</p>
{#if page === 'clean'}
  <p>Pro nastavení začátku ignorovaného rozsahu kliknětě 1s na počáteční <span class="group">?</span>  </p>
{:else if page === 'check'}
  <p>Blok typu "Nadpis" má bílé orámování: <span class="from heading">(?)?</span></p>
  <p>Blok typu "Rubrika" má červené orámování: <span class="from rubric">(?)?</span></p>
{:else if page === 'rubric'}
  <p>Pro přidání článků do rubriky klikněte na <span class="from add">+?</span> a poté přidávejte jednotlivé <span class="from">?</span> nebo <span class="from">(?)</span> z jiné rubriky</p>
  <p>Pro odebrání článku z rubriky klikněte 1s na <span class="from add">+?</span>, změní se na <span class="from remove">-?</span> a poté odebírejte jednotlivé <span class="from">(?)</span></p>
  <p>Link pro návrat do Kontroly článků se zobrazí jen když je uloženo</p>
{/if}
</section>

<style>
  span {
    padding-left: 0.3em;
    padding-right: 0.3em;
  }

  .heading {
    border: 2px solid white;
  }

  .rubric {
    border: 2px solid red;
  }

  .add {
    background-color : green;
  }

  .remove {
    background-color: red;
  }
</style>